var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditQuestionDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ABABAB",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.83 3.413c-9.044 0-16.349 7.32-16.349 16.38l.006.414c.083 3.17 1.114 6.318 2.947 8.99l.019.022.005.05-3.005 7.1 7.156-3.044-.165-.11c2.834 1.952 5.978 2.958 9.386 2.958 9.044 0 16.349-7.32 16.349-16.38 0-9.06-7.305-16.38-16.349-16.38zm0 1.56c8.181 0 14.789 6.621 14.789 14.82 0 8.2-6.608 14.82-14.789 14.82l-.42-.005c-2.785-.075-5.363-.899-7.728-2.441l-.171-.116-.022-.033a.932.932 0 00-.46-.33c-.163-.056-.256-.062-.474-.062l-.108.012c-.249.036-.472.136-.626.31l-.021.027-3.407 1.448 1.63-3.846v-.158a2.53 2.53 0 00-.032-.46l-.029-.142a1.308 1.308 0 00-.237-.504l-.02-.022.015.023c-1.735-2.53-2.679-5.53-2.679-8.52 0-8.2 6.608-14.82 14.789-14.82z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.856 24.957c-.33 0-.66-.331-.66-.662v-3.81c0-.332.33-.663.66-.663 1.984 0 3.638-1.657 3.638-3.645 0-1.987-1.654-3.644-3.638-3.644-1.983 0-3.637 1.657-3.637 3.644 0 .332-.33.663-.661.663-.33 0-.661-.331-.661-.663 0-2.816 2.314-5.135 5.125-5.135 2.81 0 5.125 2.32 5.125 5.135 0 2.485-1.819 4.639-4.299 4.97v3.148c-.33.33-.66.662-.992.662z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.988,
    cy: 27.788,
    r: 1.462
  }))));
}
export default SvgEditQuestionDisabled;